<template>
  <div class="container">
    <div class="container-item" v-for="(item,index) in list" :key="index"
         :style="{'backgroundImage': `url(${getImg(index)})`}"
    >
      <div class="container-item-text">{{item}}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:["ISO9001质量服务体系","ISO14001环境管理体系","ISO45001职业健康安全管理体系","ISO27001信息安全管理体系"]
    };
  },
  methods: {
    getImg(index) {
      return require(`../assets/assetsNewImg/product/system-${index + 1}.png`);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  height: 219px;
  background-color: #224895;
  box-sizing: border-box;
  padding-top: 30px;
  display: flex;
  justify-content: center;
  .container-item {
    width: 136px;
    height: 136px;
    margin-right: 140px;
    position: relative;
    background-size: 100%;
    &:last-child {
      margin-right: 0;
    }
    .container-item-text {
      color: #FFF;
      font-size: 16px;
      position: absolute;
      top:146px;
      left: -82px;
      width:300px;
      text-align: center;
    }
  }
}
</style>
